import {useQuery} from 'react-query'
import {GroupPricingEditModalForm} from './GroupPricingEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getGroupPricingById} from '../core/_requests'

const GroupPricingEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: grouppricing,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-grouppricing-${itemIdForUpdate}`,
    () => {
      return getGroupPricingById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <GroupPricingEditModalForm isGroupPricingLoading={isLoading} grouppricing={{id: undefined}} />
  }

  if (!isLoading && !error && grouppricing) {
    console.log({grouppricing, },"its grouppricing")
    console.log(typeof grouppricing,"its grouppricing")
    return <GroupPricingEditModalForm isGroupPricingLoading={isLoading} grouppricing={grouppricing} />
  }

  return null
}

export {GroupPricingEditModalFormWrapper}
